export async function rolesDeleteUseCase(role_id, roleRepository) {
    const result = await roleRepository.delete(role_id);

    return result;
}